import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './forgotpasswordsuccess.html';

@WithRender
@Component
export default class ForgotPasswordSuccess extends Vue {
}
